import { html } from "../../render";
import { attr, cn, spreadAttrs } from "../../utils";
const formFieldManagedAttrs = [
    "data-lp-component",
    "class",
    "data-required",
];
export function LpFormField({ label, description, error, required = false, className, attributes, children, }) {
    return html `
        <div
            data-lp-component="FormField"
            class="${cn("lp-form-field", className, attributes?.class)}"
            ${attr("data-required", required)}
            ${spreadAttrs(attributes, { omit: formFieldManagedAttrs })}
        >
            ${label
        ? html `
                    <span class="lp-form-field_label">
                        ${label}
                        ${required ? html `<span class="lp-form-field_required" aria-hidden="true">*</span>` : ""}
                    </span>
                `
        : ""}
            ${description ? html `<span class="lp-form-field_description">${description}</span>` : ""}
            ${children}
            ${error ? html `<span class="lp-form-field_error">${error}</span>` : ""}
        </div>
    `;
}
